import { useDispatch } from "react-redux";
import useEffectOnMount from "../useEffectOnMount";

type Actions =
  | ((...args: Array<any>) => any)
  | Record<string, any>
  | (((...args: Array<any>) => any) | Record<string, any>)[];

export default function useDispatchOnMount(actions: Actions) {
  const _actions = Array.isArray(actions) ? actions : [actions];

  const dispatch = useDispatch();

  useEffectOnMount(() => {
    _actions.forEach(action => {
      dispatch(typeof action === "function" ? action() : action);
    });
  });
}
